document.addEventListener("DOMContentLoaded", function () {
  // create web component for 'fixed-atc'
  class FixedAtc extends HTMLElement {
    constructor() {
      super();
      this.isInCart = false;
      this.init();
    }

    init() {
      this.button = this.querySelector("[data-fixed-atc-button]");
      this.variantId = this.button?.dataset.varId;
      this.sellingPlanId = this.button?.dataset.sellingPlanId;
      this.isProductLink = this.button?.dataset.isProductLink === "true";
      this.productLinkUrl = this.button?.dataset.productLinkUrl;
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      // Check if item is already in cart
      this.checkIfInCart();

      // Set up scroll listener
      this.setupScrollListener();

      // Set up click listener
      this.setupClickListener();
    }

    async checkIfInCart() {
      if (!this.variantId) return;

      try {
        const response = await fetch("/cart.js");
        const cartData = await response.json();

        // Check if current variant is in cart
        this.isInCart = cartData.items.some(
          (item) => item.variant_id.toString() === this.variantId.toString()
        );

        // If item is in cart, don't show the button
        if (this.isInCart) {
          this.classList.remove("active");
        }
      } catch (error) {
        console.error("Error checking cart:", error);
      }
    }

    setupScrollListener() {
      // Create a sentinel element to track when this component's position comes into view
      // Since the element is position:fixed, we need a reference point in the DOM
      const sentinel = document.createElement("div");
      sentinel.style.position = "absolute";
      sentinel.style.width = "1px";
      sentinel.style.height = "1px";
      sentinel.style.pointerEvents = "none";
      sentinel.style.visibility = "hidden";

      // Insert sentinel right before the fixed-atc element
      this.parentNode.insertBefore(sentinel, this);

      // Use Intersection Observer to detect when the sentinel (and thus the component's DOM position) comes into view
      const observerOptions = {
        root: null, // Use viewport as root
        rootMargin: "0px",
        threshold: 0, // Trigger as soon as any part of the element is visible
      };

      const observerCallback = (entries) => {
        entries.forEach((entry) => {
          if (this.isInCart) {
            this.classList.remove("active");
            return;
          }

          const sentinelRect = sentinel.getBoundingClientRect();

          // Show component when sentinel is in view OR when scrolled past it (above viewport)
          // Hide component when sentinel is below viewport (scrolled back up or haven't reached it)
          if (entry.isIntersecting || sentinelRect.bottom < 0) {
            // Sentinel is in viewport or we've scrolled past it - show component
            this.classList.add("active");
          } else if (sentinelRect.top > window.innerHeight) {
            // Sentinel is below viewport (scrolled back up) - hide component
            this.classList.remove("active");
          }
        });
      };

      const observer = new IntersectionObserver(
        observerCallback,
        observerOptions
      );
      observer.observe(sentinel);

      // Check initial scroll position on load
      const checkInitialPosition = () => {
        if (this.isInCart) {
          this.classList.remove("active");
          return;
        }

        const sentinelRect = sentinel.getBoundingClientRect();

        // Show if sentinel is in view or we've scrolled past it (above viewport)
        // Hide if sentinel is below viewport
        if (sentinelRect.bottom <= window.innerHeight) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      };

      // Check after a brief delay to ensure DOM is ready
      setTimeout(checkInitialPosition, 100);

      // Also check on scroll to handle cases where Intersection Observer might miss it
      const handleScroll = () => {
        if (this.isInCart) {
          this.classList.remove("active");
          return;
        }

        const sentinelRect = sentinel.getBoundingClientRect();

        // Show if sentinel is in view or we've scrolled past it (above viewport)
        // Hide if sentinel is below viewport (scrolled back up or haven't reached it)
        if (sentinelRect.bottom <= window.innerHeight) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      };

      window.addEventListener("scroll", handleScroll, { passive: true });

      // Store observer and sentinel for cleanup if needed
      this._intersectionObserver = observer;
      this._sentinel = sentinel;
    }

    setupClickListener() {
      if (!this.button) return;

      this.button.addEventListener("click", (e) => {
        e.preventDefault();

        // Navigate to product page if this is a product link route
        if (this.isProductLink && this.productLinkUrl) {
          window.location.href = this.productLinkUrl;
          return;
        } else {
          this.addToCart();
        }
      });
    }

    addToCart() {
      if (!this.variantId) {
        console.error("No variant ID found");
        return;
      }

      // Show loading state
      this.button.classList.add("loading");
      this.button.disabled = true;

      // Prepare request
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData();
      formData.append("id", this.variantId);
      formData.append("quantity", 1);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      // Add selling plan if available
      if (this.sellingPlanId) {
        formData.append("selling_plan", this.sellingPlanId);
      }

      // Make add to cart request
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((data) => {
          console.log(data, this.cart);
          this.handleSuccess(data);
          //   this.handleSuccess(data);
        })
        .catch((error) => {
          console.error("Add to cart error:", error);
          this.handleError("An error occurred while adding to cart");
        })
        .finally(() => {
          // Remove loading state
          this.button.classList.remove("loading");
          this.button.disabled = false;
        });
    }

    handleSuccess(data) {
      if (this.cart) this.cart.renderContents(data);
      if (this.cart && this.cart.classList.contains("is-empty")) {
        this.cart.classList.remove("is-empty");
      }

      // Mark item as in cart and hide the button
      this.isInCart = true;
      this.classList.remove("active");
    }

    handleError(message) {
      // Show error message or handle as needed
      console.error("Cart error:", message);

      // You could show a toast notification or other error handling here
      alert(message);
    }
  }

  // init the component for every instance of 'fixed-atc'
  customElements.define("fixed-atc", FixedAtc);
});
